export class Utils {
    static getBranchNameById(branchId, allBranches) {
        let name;
        for (const b of allBranches) {
            if (branchId === b.branch_id) {
                name = `/${b.tag_name}`;
                break;
            }
        }
        return name ? name : '/all'
    }
}
